<script setup lang="ts">
import CompleteLink from './CompleteLink/index.vue'

interface IProps {
  horizontal?: boolean
}

defineProps<IProps>()

const { colors } = useTheme()
const userStripeAccount = useUserStripeAccount()
const isProcessing = ref(false)

const updateProcessing = (processing: boolean) => {
  isProcessing.value = processing
}
</script>

<template>
  <div
    v-if="userStripeAccount?.state !== 'complete'"
    class="flex align-start justify-between gap-2
    bg-light-orange border-0
    rounded-1 p-3
    flex-1 h-fit self-center
    cursor-initial"
    :class="{
      'flex-col': !horizontal,
    }"
  >
    <template v-if="!isProcessing">
      <div flex="~ col" gap-2 w-full>
        <div flex justify-between>
          <div flex items-center>
            <div i-bx-error-alt text-orange mr-2 w="14px" h="14px" />

            <Text bold variant="subtitle" :color="colors.orange">
              Pending Information
            </Text>
          </div>

          <CompleteLink v-if="horizontal" @update-processing="updateProcessing" />
        </div>

        <Text :color="colors.orange" variant="caption">
          {{ horizontal ? 'Complete Seller Account in order to sell prompts and receive payments.' : 'You are unable to sell prompts at the moment.' }}
        </Text>
      </div>

      <CompleteLink v-if="!horizontal" @update-processing="updateProcessing" />
    </template>
    <template v-else>
      <div flex center w-full :h="horizontal ? '38px' : '98px'">
        <div animate-spin :style="{ animationDuration: '2s' }">
          <IconSpinner :size="20" :color="colors.orange" />
        </div>
      </div>
    </template>
  </div>
</template>
